/* Hayah product gallery — desktop grid, sticky info column, mobile slider, lightbox */
(function () {
  'use strict';

  var MOBILE = window.matchMedia('(max-width: 768px)');

  function headerOffset() {
    // Height of any header pinned to the top of the viewport (sticky / fixed)
    var candidates = document.querySelectorAll(
      '.site-header, #SiteHeader, .header-wrapper, .header-sticky-wrapper, [data-section-type="header"], header'
    );
    var max = 0;
    candidates.forEach(function (el) {
      var node = el;
      while (node && node !== document.body) {
        var pos = window.getComputedStyle(node).position;
        if (pos === 'fixed' || pos === 'sticky') {
          var r = node.getBoundingClientRect();
          if (r.top <= 1 && r.bottom > 0 && r.height < window.innerHeight / 2) {
            max = Math.max(max, r.bottom);
          }
          break;
        }
        node = node.parentElement;
      }
    });
    return Math.round(max);
  }

  /* ---------- Single-image zoom viewer ---------- */
  function Zoomer(lb) {
    this.lb = lb;
    this.stage = lb.querySelector('[data-hayah-lightbox-stage]');
    this.img = lb.querySelector('[data-hayah-lightbox-img]');
    this.s = 1; this.x = 0; this.y = 0;
    this.touch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    this.max = this.touch ? 4 : 2.5;
    this.bind();
  }

  Zoomer.prototype.bind = function () {
    var self = this;
    var stage = this.stage;

    this.lb.querySelector('[data-hayah-lightbox-close]').addEventListener('click', function () { self.close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !self.lb.hidden) self.close();
    });
    window.addEventListener('resize', function () { if (!self.lb.hidden) self.reset(false); });

    // Desktop: click to zoom in / out, move the mouse to look around
    stage.addEventListener('click', function (e) {
      if (self.touch) return;
      if (self.s > 1.01) { self.reset(true); return; }
      if (e.target !== self.img) { self.close(); return; }
      self.animate();
      self.s = self.max;
      self.follow(e.clientX, e.clientY);
    });
    stage.addEventListener('mousemove', function (e) {
      if (self.touch || self.s <= 1.01) return;
      self.follow(e.clientX, e.clientY);
    });

    // Touch: pinch to zoom, drag to pan, double-tap to toggle
    var pinch = null, pan = null, lastTap = 0, lastTapX = 0, lastTapY = 0;
    function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
    function mid(a, b) { return { x: (a.clientX + b.clientX) / 2, y: (a.clientY + b.clientY) / 2 }; }

    stage.addEventListener('touchstart', function (e) {
      e.preventDefault();
      self.lb.classList.remove('is-animating');
      if (e.touches.length === 2) {
        var m = mid(e.touches[0], e.touches[1]);
        pinch = { d: dist(e.touches[0], e.touches[1]), s: self.s, x: self.x, y: self.y, mx: m.x, my: m.y };
        pan = null;
        self.hideHint();
      } else if (e.touches.length === 1) {
        var t0 = e.touches[0];
        pan = { sx: t0.clientX, sy: t0.clientY, x: self.x, y: self.y, moved: false };
        var now = Date.now();
        if (now - lastTap < 300 && Math.abs(t0.clientX - lastTapX) < 30 && Math.abs(t0.clientY - lastTapY) < 30) {
          lastTap = 0;
          pan = null;
          self.hideHint();
          if (self.s > 1.01) self.reset(true);
          else { self.animate(); self.zoomAt(t0.clientX, t0.clientY, 2.5); }
          return;
        }
        lastTap = now; lastTapX = t0.clientX; lastTapY = t0.clientY;
      }
    }, { passive: false });

    stage.addEventListener('touchmove', function (e) {
      e.preventDefault();
      if (e.touches.length === 2 && pinch) {
        var m = mid(e.touches[0], e.touches[1]);
        var s2 = Math.max(0.8, Math.min(self.max, pinch.s * dist(e.touches[0], e.touches[1]) / pinch.d));
        var b = self.box();
        var lx = (pinch.mx - b.L - pinch.x) / pinch.s;
        var ly = (pinch.my - b.T - pinch.y) / pinch.s;
        self.s = s2;
        self.x = m.x - b.L - lx * s2;
        self.y = m.y - b.T - ly * s2;
        self.clamp(true);
        self.apply();
      } else if (e.touches.length === 1 && pan && self.s > 1.01) {
        var t1 = e.touches[0];
        self.x = pan.x + (t1.clientX - pan.sx);
        self.y = pan.y + (t1.clientY - pan.sy);
        self.clamp();
        self.apply();
      }
    }, { passive: false });

    stage.addEventListener('touchend', function (e) {
      if (e.touches.length === 0) {
        pinch = null; pan = null;
        if (self.s < 1.01) self.reset(true);
        else { self.animate(); self.clamp(); self.apply(); }
      } else if (e.touches.length === 1) {
        pinch = null;
        var t2 = e.touches[0];
        pan = { sx: t2.clientX, sy: t2.clientY, x: self.x, y: self.y };
      }
    });
  };

  Zoomer.prototype.open = function (btn) {
    var img = this.img;
    var thumb = btn.querySelector('img');
    img.removeAttribute('srcset');
    img.src = thumb ? (thumb.currentSrc || thumb.src) : btn.getAttribute('data-zoom-src');
    img.alt = thumb ? thumb.alt : '';
    // swap in the high-resolution version once it has loaded
    var hi = new Image();
    var want = btn.getAttribute('data-zoom-src');
    this._want = want;
    var self = this;
    hi.onload = function () {
      if (self._want !== want || self.lb.hidden) return;
      img.src = want;
    };
    hi.src = want;

    this.lb.hidden = false;
    document.documentElement.classList.add('hayah-lightbox-open');
    this.reset(false);
    this.lb.classList.remove('hint-done');
    clearTimeout(this._hintTimer);
    this._hintTimer = setTimeout(this.hideHint.bind(this), 2500);
    var close = this.lb.querySelector('[data-hayah-lightbox-close]');
    if (close) close.focus({ preventScroll: true });
  };

  Zoomer.prototype.close = function () {
    this.lb.hidden = true;
    document.documentElement.classList.remove('hayah-lightbox-open');
    this.reset(false);
  };

  Zoomer.prototype.hideHint = function () { this.lb.classList.add('hint-done'); };

  Zoomer.prototype.animate = function () {
    var lb = this.lb;
    lb.classList.add('is-animating');
    clearTimeout(this._animTimer);
    this._animTimer = setTimeout(function () { lb.classList.remove('is-animating'); }, 260);
  };

  // Untransformed position/size of the image inside the stage
  Zoomer.prototype.box = function () {
    return {
      L: this.img.offsetLeft, T: this.img.offsetTop,
      W: this.img.offsetWidth, H: this.img.offsetHeight,
      VW: this.stage.clientWidth, VH: this.stage.clientHeight
    };
  };

  Zoomer.prototype.clamp = function (loose) {
    var b = this.box();
    var sw = b.W * this.s, sh = b.H * this.s;
    if (sw <= b.VW || loose && this.s < 1) this.x = b.VW / 2 - b.L - sw / 2;
    else this.x = Math.min(-b.L, Math.max(b.VW - b.L - sw, this.x));
    if (sh <= b.VH || loose && this.s < 1) this.y = b.VH / 2 - b.T - sh / 2;
    else this.y = Math.min(-b.T, Math.max(b.VH - b.T - sh, this.y));
  };

  Zoomer.prototype.apply = function () {
    this.img.style.transform = 'translate3d(' + this.x + 'px,' + this.y + 'px,0) scale(' + this.s + ')';
    this.lb.classList.toggle('is-zoomed', this.s > 1.01);
  };

  Zoomer.prototype.zoomAt = function (px, py, s2) {
    var b = this.box();
    var lx = (px - b.L - this.x) / this.s;
    var ly = (py - b.T - this.y) / this.s;
    this.s = s2;
    this.x = px - b.L - lx * s2;
    this.y = py - b.T - ly * s2;
    this.clamp();
    this.apply();
  };

  // Desktop: the part of the image under the mouse is what you see
  Zoomer.prototype.follow = function (px, py) {
    var b = this.box();
    var sw = b.W * this.s, sh = b.H * this.s;
    var fx = Math.max(0, Math.min(1, px / b.VW));
    var fy = Math.max(0, Math.min(1, py / b.VH));
    this.x = sw > b.VW ? -b.L - fx * (sw - b.VW) : b.VW / 2 - b.L - sw / 2;
    this.y = sh > b.VH ? -b.T - fy * (sh - b.VH) : b.VH / 2 - b.T - sh / 2;
    this.apply();
  };

  Zoomer.prototype.reset = function (animated) {
    if (animated) this.animate();
    this.s = 1; this.x = 0; this.y = 0;
    this.apply();
  };

  function HayahGallery(el) {
    this.el = el;
    this.section = el.closest('.product-section') || document;
    this.track = el.querySelector('[data-hayah-track]');
    this.items = Array.prototype.slice.call(el.querySelectorAll('[data-hayah-item]'));
    this.meta = this.section.querySelector('.product-single__meta');
    this.lightbox = this.section.querySelector('[data-hayah-lightbox]') || document.querySelector('[data-hayah-lightbox]');
    this.baseOffset = parseInt(getComputedStyle(this.section).getPropertyValue('--hg-sticky-top'), 10) || 0;
    this.current = 0;
    this.init();
  }

  HayahGallery.prototype.init = function () {
    var self = this;
    if (!this.track) return;

    // Mobile slider indicator
    var onScroll = function () { self.updateIndicator(); };
    this.track.addEventListener('scroll', onScroll, { passive: true });
    this.track.addEventListener('scrollend', onScroll, { passive: true });

    this.el.querySelectorAll('[data-hayah-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        self.goTo(parseInt(dot.getAttribute('data-hayah-dot'), 10));
      });
    });

    // Show more (desktop)
    var more = this.el.querySelector('[data-hayah-more]');
    if (more) more.addEventListener('click', function () { self.el.classList.add('is-expanded'); });

    // Lightbox (single image with zoom)
    if (this.lightbox && this.el.getAttribute('data-lightbox') === 'true') {
      if (!this.lightbox.__zoomer) this.lightbox.__zoomer = new Zoomer(this.lightbox);
      var zoomer = this.lightbox.__zoomer;
      this.el.querySelectorAll('[data-hayah-zoom]').forEach(function (btn) {
        btn.addEventListener('click', function () { zoomer.open(btn); });
      });
    }

    // Variant change → show that variant's image
    if (this.el.getAttribute('data-variant-jump') === 'true') {
      document.addEventListener('variant:change', function (e) {
        var v = e.detail && (e.detail.variant || e.detail);
        if (!v || !v.featured_media) return;
        var root = e.target && e.target.closest ? e.target.closest('.product-section') : null;
        if (root && root !== self.section) return;
        self.showMedia(v.featured_media.id);
      });
    }

    // Sticky info column
    this.updateSticky = this.updateSticky.bind(this);
    window.addEventListener('resize', this.updateSticky, { passive: true });
    window.addEventListener('scroll', this.updateSticky, { passive: true });
    if (this.meta && 'ResizeObserver' in window) {
      new ResizeObserver(this.updateSticky).observe(this.meta);
    }
    this.updateSticky();

    // Start on the selected variant's image on mobile
    var featured = this.el.querySelector('.hayah-gallery__item.is-featured');
    if (featured && MOBILE.matches) {
      var idx = this.items.indexOf(featured);
      if (idx > 0) this.track.scrollLeft = featured.offsetLeft;
    }
  };

  HayahGallery.prototype.updateSticky = function () {
    var mode = this.el.getAttribute('data-sticky');
    if (!this.meta || MOBILE.matches || mode === 'off') return;
    var top = headerOffset() + this.baseOffset;
    if (mode === 'follow') {
      // Scroll until the bottom of the info is visible, then hold it there.
      var vh = window.innerHeight;
      var h = this.meta.offsetHeight;
      if (h + top + this.baseOffset > vh) top = vh - h - Math.max(this.baseOffset, 24);
    }
    // 'pinned': stays just under the header (Calvin Klein style) until the gallery ends.
    if (this._lastTop !== top) {
      this._lastTop = top;
      this.section.style.setProperty('--hg-sticky-top', top + 'px');
    }
  };

  HayahGallery.prototype.updateIndicator = function () {
    var w = this.track.clientWidth;
    if (!w) return;
    var first = this.items[0];
    var step = this.items[1] ? this.items[1].offsetLeft - first.offsetLeft : w;
    var i = Math.round(this.track.scrollLeft / step);
    i = Math.max(0, Math.min(this.items.length - 1, i));
    if (i === this.current) return;
    this.current = i;
    this.el.querySelectorAll('[data-hayah-dot]').forEach(function (d, n) {
      d.classList.toggle('is-active', n === i);
    });
    var bar = this.el.querySelector('[data-hayah-bar]');
    if (bar) bar.style.transform = 'translateX(' + i * 100 + '%)';
    var count = this.el.querySelector('[data-hayah-count]');
    if (count) count.textContent = i + 1;
  };

  HayahGallery.prototype.goTo = function (i) {
    var item = this.items[i];
    if (!item) return;
    this.track.scrollTo({ left: item.offsetLeft - this.items[0].offsetLeft, behavior: 'smooth' });
  };

  HayahGallery.prototype.showMedia = function (mediaId) {
    var item = this.el.querySelector('[data-media-id="' + mediaId + '"]');
    if (!item) return;
    var i = this.items.indexOf(item);
    if (MOBILE.matches) {
      this.goTo(i);
    } else {
      if (item.classList.contains('hayah-gallery__item--desk-hidden')) this.el.classList.add('is-expanded');
      var r = item.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.6) {
        window.scrollTo({ top: window.pageYOffset + r.top - headerOffset() - 10, behavior: 'smooth' });
      }
    }
  };

  function setViewportWidth() {
    document.documentElement.style.setProperty('--hg-vw', document.documentElement.clientWidth + 'px');
  }
  setViewportWidth();
  window.addEventListener('resize', setViewportWidth, { passive: true });

  function boot(scope) {
    (scope || document).querySelectorAll('[data-hayah-gallery]').forEach(function (el) {
      if (el.__hayah) return;
      el.__hayah = new HayahGallery(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
